<template>
  <div>
      <div class="full-width bg-grey-10" style="height: 1px;"></div>
      <div style="display: flex; justify-content: flex-start; flex-flow: row wrap; align-items: center; padding: 1rem; font-weight: bold;">
          <div style="width: 25%;">
            <p>{{$t('finances_revenues')}} {{ time}}</p>
            <span style="color: green;">{{revenue}}</span>
          </div>
          <div style="width: 25%; margin-left: 2rem;">
            <p>{{$t('finances_expenses')}} {{time}}</p>
            <span style="color: red;">{{expense}}</span>
          </div>
      </div>
      <div class="full-width bg-grey-10" style="height: 1px;"></div>
  </div>
</template>

<script>
  export default {
    props: {
      time: {
        type: String | Number,
        required: true
      },
      expense: {
        type: Number,
        required: true
      },
      revenue: {
        type: Number,
        required: true
      }
    }
  }
</script>
